import apiPembelian from '@/api/seller/pembelian';

const defaultState = () => ({
	loadPesanan: false,
	historyTrackingData: [],
	statusPembelian: null,
	listProduk: [],
	listSupplier: [],
	pembelianData: [],
	loadPembelian: false,
	detailPembelian: {},
	pembelianPagination: '',
	shippingFees: null,
	shippingFeesInstant: null,
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: '',
	resellerTypeValue: '',
	detailPesanan: {},


});

const state = defaultState();

const getters = {};

const mutations = {
	setPesananDetail(state, data) {
		state.detailPesanan = data
	},
	setloadPesanan(state, data) {
		state.loadPesanan = data
	},
	setResellerTypeValue(state, data) {
		state.resellerTypeValue = data
	},
	setHistoryTracking(state, data) {
		state.historyTrackingData = data.data
	},
	setStatus(state, data) {
		state.statusPembelian = data.data
	},
	setListSupplier(state, data) {
		state.listSupplier = data.data
	},
	setListProduk(state, data) {
		state.listProduk = data.data
	},
	setPembelian(state, data) {
		state.pembelianData = data.data
		state.pembelianPagination = data.pagination;
	},
	setloadPembelian(state, data) {
		state.loadPembelian = data
	},
	setDetailPembelian(state, data) {
		state.detailPembelian = data
	},
	setShippingFee(state, data) {
		state.shippingFees = data
	},
	setShippingFeeInstant(state, data) {
		state.shippingFeesInstant = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearPesanan(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	uploadImage({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiPembelian.uploadImage(params).then(({ data }) => {
				dispatch('success', data)
				// commit('auth/setImageData', data.data.image, { root: true })
				resolve(data);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	getCourierMarketplace({ commit }, ) {
		commit('setloadPembelian', true);
		return new Promise((resolve) => {
			apiPembelian.getCourierMarketplace().then(({ data: { data } }) => {
				// console.log("courier:", data)
				resolve(data.data);
			}).then(() => {
				commit('setloadPembelian', false);
			});
		});
	},
	getResellerType({ commit }, ) {
		commit('setloadPembelian', true);
		return new Promise((resolve) => {
			apiPembelian.getResellerType().then(({ data: { data } }) => {
				// console.log("data", data)
				commit('setResellerTypeValue', data.reseller_type);
				resolve(true);
			}).then(() => {
				commit('setloadPembelian', false);
			});
		});
	},
	getHistoryTracking({ commit }, params) {
		commit('setloadPembelian', true);
		return new Promise((resolve) => {
			apiPembelian.getHistoryTracking(params).then(({ data: { data } }) => {
				commit('setHistoryTracking', { data: data.results });
				resolve(true);
			}).then(() => {
				// commit('setloadPesanan', false);
				commit('setloadPembelian', false);
			});
		});
	},
	getTrackingKiriminaja({ commit }, params) {
		commit('setloadPembelian', true);
		return new Promise((resolve) => {
			apiPembelian.getTrackingKiriminaja(params).then(({ data: { data } }) => {
				// commit('setPesanan', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).then(() => {
				// commit('setloadPesanan', false);
				commit('setloadPembelian', false);
			});
		});
	},
	getTracking({ commit }, params) {
		commit('setloadPembelian', true);
		return new Promise((resolve) => {
			apiPembelian.getTracking(params).then(({ data: { data } }) => {
				// commit('setPesanan', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).then(() => {
				// commit('setloadPesanan', false);
				commit('setloadPembelian', false);
			});
		});
	},
	getStatusPembelian({ commit }, params) {
		return new Promise((resolve) => {
			apiPembelian.getStatusPembelian(params).then(({ data: { data } }) => {
				commit('setStatus', { data: data.results });
				resolve(true);
			}).catch(() => {
				commit('setStatus', { data: [] });
			}).then(() => {

			});
		});
	},
	getPesananDetailShipmentAdmin({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPembelian.getPesananDetailShipmentAdmin(params).then(({ data: { data } }) => {
				commit('setPesananDetail', data.results);
				resolve(true);
			}).catch(() => {
				commit('setPesananDetail', {});
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},
	getListSupplier({ commit }, params) {
		return new Promise((resolve) => {
			apiPembelian.getListSupplier(params).then(({ data: { data } }) => {
				commit('setListSupplier', { data: data.results });
				resolve(true);
			}).catch(() => {
				commit('setListSupplier', { data: [] });
			}).then(() => {

			});
		});
	},
	getListProduk({ commit }, params) {
		return new Promise((resolve) => {
			apiPembelian.getListProduk(params).then(({ data: { data } }) => {
				commit('setListProduk', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setListProduk', { data: [] });
			}).then(() => {

			});
		});
	},
	getListProdukPrint({ commit }, params) {
		return new Promise((resolve) => {
			apiPembelian.getListProduk(params).then(({ data: { data } }) => {
				// commit('setListProduk', { data: data.results ,pagination:data.pagination});
				resolve({ data: data.results, pagination: data.pagination });
			}).catch(() => {
				// commit('setListProduk', { data: [] });
			}).then(() => {

			});
		});
	},

	getPembelian({ commit }, params) {
		commit('setloadPembelian', true);
		return new Promise((resolve) => {
			apiPembelian.getPembelian(params).then(({ data: { data } }) => {
				commit('setPembelian', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setPembelian', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadPembelian', false);
			});
		});
	},

	getPembelianDetail({ commit }, params) {
		commit('setloadPembelian', true);
		return new Promise((resolve) => {
			apiPembelian.getPembelianDetail(params).then(({ data: { data } }) => {
				commit('setDetailPembelian', data.results);
				resolve(true);
			}).catch(() => {
				commit('setDetailPembelian', {});
			}).then(() => {
				commit('setloadPembelian', false);
			});
		});
	},
	getPembelianDetailAdmin({ commit }, params) {
		commit('setloadPembelian', true);
		return new Promise((resolve) => {
			apiPembelian.getPembelianDetailAdmin(params).then(({ data: { data } }) => {
				commit('setDetailPembelian', data.results);
				resolve(true);
			}).catch(() => {
				commit('setDetailPembelian', {});
			}).then(() => {
				commit('setloadPembelian', false);
			});
		});
	},
	getShippingFee({ commit }, params) {
		commit('setloadPembelian', true);
		return new Promise((resolve) => {
			apiPembelian.getShippingFee(params).then(({ data: { data } }) => {
				commit('setShippingFee', data.results);
				resolve(true);
			}).catch(() => {
				commit('setShippingFee', {});
			}).then(() => {
				commit('setloadPembelian', false);
			});
		});
	},
	getShippingFeeKiriminajaExpress({ dispatch, commit }, params) {
		commit('setloadPembelian', true);
		commit('setShippingFee', null);

		return new Promise((resolve, reject) => {
			apiPembelian.getShippingFeeKiriminajaExpress(params).then(({ data: { data } }) => {
				if (params.weight <= 0) {
					commit('setShippingFee', null);
				} else {
					commit('setShippingFee', data.results);
				}
				resolve(true);
			}).catch((err) => {
				commit('setShippingFee', null);
				commit('setloadPembelian', false);
				// dispatch('errorHandler', data);
				// reject(data)
				reject(err.message)
			}).then(() => {
				commit('setloadPembelian', false);
			});
		});
	},
	getShippingFeeKiriminajaInstant({ dispatch, commit }, params) {
		commit('setloadPembelian', true);
		commit('setShippingFeeInstant', null);

		return new Promise((resolve, reject) => {
			apiPembelian.getShippingFeeKiriminajaInstant(params).then(({ data: { data } }) => {
				if (params.weight <= 0) {
					commit('setShippingFeeInstant', null);
				} else {
					commit('setShippingFeeInstant', data.results);
				}
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				commit('setShippingFeeInstant', null);
				commit('setloadPembelian', false);
				// dispatch('errorHandler', data);
				// reject(data)
				reject(data.message)
			}).then(() => {
				commit('setloadPembelian', false);
			});
		});
	},
	async saveSnap({ dispatch }, params) {
		return new Promise(async (resolve, reject) => {
			await apiPembelian.saveSnap(params).then(({ data: { data } }) => {
				dispatch('success', data)
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data.message)
				dispatch('errorHandler', data);
			})
		});
	},
	createPembelianKiriminaja({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPembelian.createPembelianKiriminaja(params).then((data) => {
				dispatch('success', data)
				// resolve(true);
				resolve(data);
			}).catch((err) => {
				// reject(true)
				const { data } = err.response;
				// console.log("data error", data.data)
				dispatch('errorHandler', data);
				// reject(data)
				reject(data.message)


			})
		});
	},
	createPembelian({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPembelian.createPembelian(params).then((data) => {
				dispatch('success', data)
				// resolve(true);
				resolve(data);
			}).catch((err) => {
				// reject(true)
				const { data } = err.response;
				// console.log("data error", data.data)
				dispatch('errorHandler', data);
				// reject(data)
				reject(data.message)


			})
		});
	},
	deletePembelian({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPembelian.deletePembelian(params).then((data) => {
				dispatch('success', data)
				// resolve(true);
				resolve(data);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	notificationPembelian({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPembelian.notificationPembelian(params).then((data) => {
				dispatch('success', data)
				// resolve(true);
				resolve(data);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	cancelMidtrans({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPembelian.cancelMidtrans(params).then((data) => {
				dispatch('success', data)
				// resolve(true);
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				// console.log("error data", data)
				dispatch('errorHandler', data);
				reject(true)
				// reject(data)

			})
		});
	},
	choosePayment({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPembelian.choosePayment(params).then((data) => {
				dispatch('success', data)
				// resolve(true);
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				// console.log("error data", data)
				dispatch('errorHandler', data);
				reject(true)
				// reject(data)

			})
		});
	},

	bayarPembelian({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPembelian.bayarPembelian(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},

	receivePembelian({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPembelian.receivePembelian(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},

	success({ commit }, response) {
		commit('saveResponse', response)
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
				commit('validationError', response.data);
				break;

			case 'error_multiple_alert':
				commit('multipleAlert', response.data.error)
				break;

			default:
				commit('makeAlert', { code: 'error_response', type: 'error', message: response.message, show: true }, { root: true });
				break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};